module.exports = __webpack_public_path__ + "img/img3.d00e00af.svg";